const API_URL = import.meta.env.VITE_BLOG_API_URL;
const API_KEY = import.meta.env.VITE_BLOG_API_KEY;

export const getAllBlogs = async () => {
  const response = await fetch(`${API_URL}?limit=6&page=1`, {
    method: 'POST',
    headers: {
      'x-api-key': API_KEY,
      'Content-Type': 'application/json',
      accept: 'application/json'
    },
    body: JSON.stringify({ limit: 6, page: 1, status: 'PUBLISHED' })
  });

  const data = await response.json();
  const apiBlogs = data?.data?.data || [];

  return apiBlogs.map(post => ({
    id: post.id,
    slug: post.slug,  
    title: post.title,
    excerpt: post.subTitle || post.title,
    content: post.content || { blocks: [{ id: '1', type: 'paragraph', data: { text: post.subTitle || post.title } }] },
    author: {
      name: post.authorName || 'Unknown Author',
      avatar: post.authorImage?.url || post.authorImage?.id || 'https://images.unsplash.com/photo-1511367461989-ee65bc7401d1?w=150&h=150&fit=crop&crop=face',
      role: post.authorRole || 'Contributor'
    },
    category: post.category?.name || 'Uncategorized',
    tags: Array.isArray(post.tags) ? post.tags : [],
    publishedAt: post.createdAt || new Date().toISOString(),
    readTime: post.readTime || 5,
    views: post.views || 0,
    comments: post.commentsCount || 0,
    shares: post.sharesCount || 0,
    featured: post.isFeatured || false,
    image: post.coverImage?.url || post.coverImage?.id || 'https://images.unsplash.com/photo-1517694712202-14dd9538aa97?w=800&h=400&fit=crop'
  }));
};
